module.exports = __webpack_public_path__ + "static/mpost64.22c4eedd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost64.jpg
// module id = 999
// module chunks = 35783957827783